
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic03 as ObiHydraulic03Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-03.js';
 
 
 

 
 export const ObiHydraulic03 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-03',
   elementClass: ObiHydraulic03Element,
   events: {
     
   }
  });
 
 